import { render, staticRenderFns } from "./LogItem.vue?vue&type=template&id=1821892d&scoped=true&lang=pug&"
import script from "./LogItem.vue?vue&type=script&lang=ts&"
export * from "./LogItem.vue?vue&type=script&lang=ts&"
import style0 from "./LogItem.vue?vue&type=style&index=0&id=1821892d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1821892d",
  null
  
)

export default component.exports